import Types from './types';

class ErrorHandler {
    secondsLeft = 0;
    countDown = null;
    isShowTooManyRequestsWindow = false;
    lastErrorCode = null;
    userClosedErrorWindow = false;
    static blockRequests = false;

    onCatch(error) {
        if (error && error.name === 'TypeError' && error.message === 'Failed to fetch') {
            // const message = "Please, check your internet connection";
        }

        if (error && error.cause && error.cause.status) {
            this.lastErrorCode = error.cause.status;
        }

        if (
            (error && error.cause && error.cause.status === Types.HTTP_CODE_TOO_MANY_REQUESTS) ||
            this.lastErrorCode === Types.HTTP_CODE_TOO_MANY_REQUESTS
        ) {
            this.blockRequests = true;
            this.isShowTooManyRequestsWindow = true;

            if (error && error.cause && error.cause.status) {
                this.secondsLeft = 60;
            }

            this.startTimer(
                () => this.showTooManyRequestsWindow(),
                () => (this.isShowTooManyRequestsWindow = false)
            );
        }
    }

    startTimer(startCallback, stopCallback) {
        if (!this.countDown) {
            this.countDown = setInterval(() => {
                if (this.secondsLeft === 0) return this.stopTimer(stopCallback);

                this.secondsLeft = this.secondsLeft - 1;
                startCallback();
            }, 1000);
        } else {
            startCallback();
        }
    }

    stopTimer(callback) {
        clearInterval(this.countDown);
        this.blockRequests = false;
        this.countDown = null;
        this.lastErrorCode = null;
        callback();
    }

    showTooManyRequestsWindow() {
        if (!this.isShowTooManyRequestsWindow) return;
    }
}

export default ErrorHandler;
